import {
  type Port,
  PortProtocol,
} from "@buf/brevdev_devplane.bufbuild_es/devplaneapi/v1/network_pb";
import { isLegacyNetworkAccessPort } from "utils/environment/networkAccessFallback";

const SSH_SERVER_PORT = 22;

export function getSSHPortId(ports: readonly Port[]): string | undefined {
  const skybridgePorts = ports.filter(
    (port) => port.portId && !isLegacyNetworkAccessPort(port),
  );

  const sshPort =
    skybridgePorts.find((port) => port.protocol === PortProtocol.SSH) ??
    skybridgePorts.find((port) => port.serverPort === SSH_SERVER_PORT);

  return sshPort?.portId;
}
